import { GPUBufferUsage } from './constants';
//namespace Pacem.Drawing3D.WebGPU {
export class Buffers {
    static create(device, data, label = '') {
        const buffer = device.createBuffer({
            size: data.byteLength, label,
            usage: GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST,
            mappedAtCreation: true
        });
        new Float32Array(buffer.getMappedRange()).set(data);
        buffer.unmap();
        return buffer;
    }
    static createUniform(device, data, label = '') {
        return device.createBuffer({
            size: data.byteLength, label,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST,
        });
    }
    static createStorage(device, data, label = '') {
        return device.createBuffer({
            size: data.byteLength, label,
            usage: GPUBufferUsage.STORAGE | GPUBufferUsage.COPY_DST,
        });
    }
    static createIndexed(device, data, label = '') {
        const buffer = device.createBuffer({
            size: data.byteLength, label,
            usage: GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST,
            mappedAtCreation: true
        });
        new Uint16Array(buffer.getMappedRange()).set(data);
        buffer.unmap();
        return buffer;
    }
}
export class BufferLayouts {
    static createVertex(shaderLocationStart = 0, size = 3, ...sizes) {
        const attributes = [];
        let fullSize = 0, index = 0;
        for (let sz of [size].concat(sizes)) {
            attributes.push({
                shaderLocation: shaderLocationStart + index,
                offset: fullSize * Float32Array.BYTES_PER_ELEMENT,
                format: `float32x${sz}`,
            });
            fullSize += sz;
            index++;
        }
        return {
            arrayStride: fullSize /* x, y, z */ * Float32Array.BYTES_PER_ELEMENT,
            attributes,
            stepMode: 'vertex'
        };
    }
}
